var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,{tag:"component",staticClass:"dropdown-item",attrs:{"to":_vm.to,"text":_vm.text},on:{"click":_vm.onLanguageChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }